import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const FilterContext = createContext();

export const useFilter = () => useContext(FilterContext);

export const FilterProvider = ({ children }) => {
    const [filter, setFilter] = useState('latest');
    const [filterTag, setFilterTag] = useState(null);
    const [onlyOfficial, setOnlyOfficial] = useState(false);

    // Save filter in local storage
    useEffect(() => {
        const storedFilter = Cookies.get('filter');
        if (storedFilter) {
            setFilter(storedFilter);
        }

        const storedFilterTag = Cookies.get('filterTag');
        if (storedFilterTag) {
            setFilterTag(storedFilterTag);
        }

        const storedOnlyOfficial = Cookies.get('onlyOfficial');
        if (storedOnlyOfficial) {
            saveOnlyOfficial(storedOnlyOfficial === 'true');
        }
    }, []); // Add dependency array to ensure it runs only once

    const saveFilterTag = (filterTag) => {
        setFilterTag(filterTag);
        Cookies.set('filterTag', filterTag);
    };

    const saveFilter = (filter) => {
        setFilter(filter);
        Cookies.set('filter', filter);
    };

    const saveOnlyOfficial = (onlyOfficial) => {
        setOnlyOfficial(onlyOfficial);
        Cookies.set('onlyOfficial', onlyOfficial);
    }

    return (
        <FilterContext.Provider value={{
            filter, setFilter: saveFilter,
            filterTag, setFilterTag: saveFilterTag,
            onlyOfficial, setOnlyOfficial: saveOnlyOfficial
        }}>
            {children}
        </FilterContext.Provider>
    );
};

export default FilterProvider;
